/**
 * `rosterRefusal` translations: the sentences `api/routers/roster.py` refuses with, matched in `lib/roster/rosterRefusal.ts`.
 */
export const rosterRefusal = {
  mn: {
    rosterRefusal: {
      blank: '(хоосон)',
      kind: { day: 'өдөр', night: 'шөнө', transit: 'замд', logging: 'ангор', downtime: 'сул зогсолт', tasks: 'даалгавар' },
      noProject: 'төсөлгүй',
      nothingRecorded: 'бүртгэл алга',

      layoutShape: 'rowLayout нь order ба hidden гэсэн хуваарийн нэрсийн жагсаалттай объект байх ёстой',
      layoutList: 'rowLayout.{{field}} нь хуваарийн нэрсийн жагсаалт байх ёстой',
      layoutTooMany: 'rowLayout.{{field}} {{n}} нэртэй байна; дээд тал нь {{max}}',
      layoutNameLong: 'rowLayout.{{field}} дотор {{max}} тэмдэгтээс урт нэр байна',

      personFieldLong: '{{name}}: {{field}} {{limit}} тэмдэгтээс урт байна',
      rolesNotList: '{{name}}: үүргүүд жагсаалт байх ёстой',
      rolesTooMany: '{{name}}: дээд тал нь {{max}} үүрэг',
      rolesDuplicate: '{{name}}: үүрэг давхардсан байна',
      rolesUnknown: '{{name}}: тохиргооны үүргийн жагсаалтад алга: {{roles}}',
      roleFirst: '{{name}}: үндсэн үүрэг нь жагсаалтын эхний үүрэгтэй ижил байх ёстой',

      managerRequired: 'Зөвхөн ээлжийн менежер үүнийг хийнэ: ээлжинд байгаа бүтэн цагийн ажилтан ээлжийн менежерийн эрхтэй байх ёстой. Админаас асууна уу.',
      noRole: 'Танд ээлжийн эрх алга. Ээлжийн менежерээс асууна уу.',
      leaver: 'Та ажлаас гарсан тул ээлжийн хуваарьт хандах эрхгүй',
      noAccessLevel: 'Таны бүртгэлд хандах эрхийн түвшин алга',
      noProjectPublished: 'Та нийтлэгдсэн хуваарийн аль ч төсөлд алга',
      managerNotFullTime: 'Танд ээлжийн менежерийн эрх бий ч зөвхөн хуваарьт байгаа бүтэн цагийн дотоод ажилтан төлөвлөнө. Админаас асууна уу.',
      onlyManagerPlans: 'Зөвхөн ээлжийн менежер төлөвлөнө',
      noProjectYet: 'Та одоогоор ямар ч төсөлд алга',

      cellChanged: 'Хадгалах явцад энэ өдрийг өөр газраас өөрчилсөн. Дахин ачаалаад оролдоно уу',
      noRosterYet: 'Энэ компанид ээлжийн хуваарь хараахан алга',

      pastPlan: 'Өнгөрсөн өдөрт хуваарь төлөвлөх боломжгүй: өнөөдөр {{today}}, татгалзсан өдөр: {{days}}.',
      pastPlanAdmin: 'Өнгөрсөн өдөрт хуваарь төлөвлөх боломжгүй: өнөөдөр {{today}}, татгалзсан өдөр: {{days}}. Админ өөрчилж болно.',
      futureFile: 'Болоогүй өдөрт ээлж бүртгэх боломжгүй: өнөөдөр {{today}}, татгалзсан өдөр: {{days}}.',
      closedMonth: '{{days}} нь хаагдсан {{month}} цалингийн сард багтдаг тул хуваарь төлөвлөх боломжгүй. Админ өөрчилж болно.',

      eligibleShape: 'eligible нь төсөл тус бүрийн id жагсаалт байх ёстой',
      eligibleList: 'eligible[{{project}}] жагсаалт байх ёстой',
      eligibleNotId: 'eligible[{{project}}]: id биш байна: {{value}}',

      staffListOf: '{{project}} төслийн ээлжийн ажилтнууд хүний id жагсаалт байх ёстой',
      staffIds: 'Ээлжийн ажилтан хүний id байх ёстой: {{value}}',
      staffMapShape: 'staff нь төсөл тус бүрийн хүний id жагсаалт байх ёстой',
      staffNotPerson: 'Ээлжийн ажилтан хуваарьт байгаа хүн байх ёстой: {{value}}',
      staffNoHome: 'Ээлжийн ажилтан хуваарьт байгаа үндсэн төсөлтэй байх ёстой: {{value}}',
      staffNotProject: '{{who}} {{project}}-ийн ээлжийн ажилтан болох боломжгүй: энэ нь хуваарьт байгаа төсөл биш',
      staffExternalNamed: '{{who}} {{project}}-ийн ээлжийн ажилтан болох боломжгүй: зөвхөн {{staff}} ээлжийн ажилтан болно, энэ хүн гадны ажилтан',
      staffExternalOwn: '{{who}} {{project}}-ийн ээлжийн ажилтан болох боломжгүй: зөвхөн компанийн өөрийн ажилтан ээлжийн ажилтан болно, энэ хүн гадны ажилтан',
      staffNotPart: '{{who}} {{project}}-ийн ээлжийн ажилтан болох боломжгүй: энэ хүн уг төсөлд хамаарахгүй (үндсэн төсөл нь биш, нийтлэгдсэн ээлж ч алга)',

      versionStale: 'Таныг ачаалснаас хойш хуваарь өөрчлөгдсөн. Хуудсыг дахин ачаалаад өөрчлөлтөө дахин хийнэ үү.',
      cityOnlyWriters: 'Хотод байх өдрийг зөвхөн ээлжийн менежер эсвэл хүний нөөц тэмдэглэнэ.',
      cityNotOnRoster: 'Энэ хүн хуваарьт алга.',
      cityEndBeforeStart: 'Дуусах огноо эхлэх огнооноос өмнө байна.',
      cityMarkTooLong: 'Нэг тэмдэглэгээ дээд тал нь {{max}} хоног хамарна.',
      cityNoMark: 'Энэ тэмдэглэгээ устсан байна. Хуудсыг дахин ачаална уу.',
      productNotFound: 'Энэ төсөл олдсонгүй. Хуудсыг дахин ачаална уу.',
      onlyProjectOnRoster: 'Хуваарьт зөвхөн төсөл байж болно.',
      projectNeedsMongolian: 'Хуваарьт байгаа төсөлд монгол нэр хэрэгтэй.',
      onlyManagerSetsProjects: 'Төслийг зөвхөн ээлжийн менежер тохируулна. Ээлжийн менежерээс асууна уу.',
      rosterNameUsed: '{{project}} хуваарьт {{name}} нэрийг ашиглаж байна.',
      rosterNameEnglish: '{{name}} бол өөр бүтээгдэхүүний англи нэр. Хуваарийн өөр нэр сонгоно уу.',
      projectInUseRenamed: 'Хуваарьт ашиглагдаж байгаа ({{uses}}) тул {{project}}-г нэрийг нь өөрчлөх боломжгүй. Эхлээд тэдгээрийг цэвэрлэнэ үү.',
      projectInUseOff: 'Хуваарьт ашиглагдаж байгаа ({{uses}}) тул {{project}}-г хуваариас хасах боломжгүй. Эхлээд тэдгээрийг цэвэрлэнэ үү.',
      viewingReadOnly: '{{who}}-ийн нэрээр харж байх үед зөвхөн унших боломжтой. Харахаа зогсоогоод дахин оролдоно уу.',
      accountInactive: 'Энэ бүртгэл идэвхгүй байна. Админаас асууна уу.',
      leaverPayslips: 'Таны ажил дууссан тул энэ бүртгэлээр зөвхөн өөрийн цалингийн хуудсыг харна.',
      noAccessGranted: 'Энэ бүртгэлд хандах эрхийн түвшин алга тул энд харуулах зүйлгүй. Хандах эрх хараахан олгоогүй байна.',
      publicViewOnly: 'Энэ бол зөвхөн компанийн самбар, хуанли харуулдаг нийтийн харагдац. Энэ хуудсыг нээх боломжгүй.',
      noEverydayPages: 'Энэ бүртгэлийн хандах эрхийн түвшинд ажилтны өдөр тутмын хуудсууд ороогүй. Зөвхөн түвшинд нь заасан хуудсуудыг нээнэ.',
      missingPermission: 'Танд үүнийг хийх эрх алга ({{ability}}).',
      adminRequired: 'Үүнийг зөвхөн админ хийнэ.',
      tickAdmin: 'Админ үргэлж ээлжийн менежер тул тэмдэглэх шаардлагагүй.',
      tickNotStaff: 'Зөвхөн ээлжинд байгаа бүтэн цагийн дотоод ажилтан ээлжийн менежер болно.',
      tickNoAccount: 'Энэ хүнд энгийн бүртгэл байхгүй тул тэмдэглэгээ ажиллахгүй.',
      tickPasswordHolder: 'Энэ хүн нууц үгээр нэвтэрдэг, харин ээлжийн менежер зөвхөн Microsoft-оор нэвтэрнэ. Эхлээд нууц үгийг нь устгана уу.',
      tickNeedsEmail: 'Ээлжийн менежер имэйлээр ирсэн кодоор нэвтэрдэг, харин энэ хүнд имэйл алга. Эхлээд имэйл оруулна уу.',
      userNotFound: 'Энэ хүн олдсонгүй. Хуудсыг дахин ачаална уу.',
      stringTooLong: 'Хэт урт байна: дээд тал нь {{max}} тэмдэгт.',
      stringTooShort: 'Хэт богино байна: доод тал нь {{min}} тэмдэгт.',
      publishedView: 'Энэ хуваарийг нийтлэгдсэн, шүүсэн хэлбэрээр ачаалсан тул хадгалах боломжгүй. Хуудсыг дахин ачаалаад өөрчлөлтөө дахин хийнэ үү',
      planReadOnly: 'Төлөвлөгөө зөвхөн Нийтлэх эсвэл Цэвэрлэхээр өөрчлөгдөнө. Хуудсыг дахин ачаалаад өөрчлөлтөө Ноорогт хадгална уу',
      namesUnresolved: 'Эдгээр хуваарийн нэр хэнтэй ч таарахгүй байна: {{names}}. Одоо байгаа хүний доор нэмэх, эсвэл админаар нэрийн холбоосыг нь бүртгүүлнэ үү',
      planProjectUnknown: 'planProject: хуваарийн төсөл биш: {{projects}}',

      codeExact: '{{code}} кодын төрөл {{act}}: T эсвэл DT код яг төрлөөрөө нэрлэгдэх ёстой (T нь T, DT нь DT)',
      codeCategory: '{{code}} код аль хэдийн байгаа тул ангиллыг нь өөрчлөх боломжгүй',
      codeNoProject: '{{code}} код төсөлгүй: төсөлд холбогдоогүй код нэмэх боломжгүй',
      codeFixedRemoved: '{{code}} код төсөлд холбогдоогүй тул устгах, нэрийг нь өөрчлөх боломжгүй',
      codeFixedGivenProject: '{{code}} код төсөлд холбогдоогүй тул төсөл оноох боломжгүй',
      codeFixedType: '{{code}} код төсөлд холбогдоогүй тул төрлийг нь өөрчлөх боломжгүй',

      stackSameType: 'Нэг өдөрт ижил төрлийн ({{type}}) хоёр ээлж байх боломжгүй: {{value}}',
      stackTooMany: 'Нэг өдөрт хоёроос олон ээлж байх боломжгүй: {{value}}',
      hoursTransit: 'Замын цагт кодонд T байх ёстой, код нь {{code}}',
      hoursDowntime: 'Сул зогсолтын цагт кодонд DT байх ёстой, код нь {{code}}',
      hoursTOnly: 'T өдөр зөвхөн замын цагтай байна, энэ өдөрт бас {{kinds}} цаг байна',

      massClear: 'Төлөвлөсөн {{n}} нүд цэвэрлэгдэнэ. Цэвэрлэхийг баталгаажуулна уу',

      publishBeforeToday: 'Нийтлэх эцсийн огноо ({{day}}) өнөөдрөөс ({{today}}) өмнө байна.',
      cleanBeforeToday: 'clean_from: {{day}} нь өнөөдрөөс ({{today}}) өмнө байна; өнгөрсөн өдрүүд хэвээр үлдэнэ',
      cleanToBefore: 'clean_to: {{to}} нь {{from}}-ээс өмнө байна',
      unknownProject: 'Хуваарьт ийм төсөл алга: {{project}}',
      unknownName: 'Хуваарьт ийм нэр алга: {{name}}',
      homeNotProject: '{{home}} нь хуваарийн төслүүдийн нэг биш',
      noSuchPerson: 'Ийм хүн алга',
      notActiveStaff: '{{name}} идэвхтэй хүний нөөцийн ажилтан биш бөгөөд бүртгэх сүүлийн ажлын өдөр нь ч үлдээгүй. Эндээс зөвхөн тийм ажилтныг хуваарьт нэмнэ',
      alreadyOnRoster: '{{name}} хуваарьт аль хэдийн байна',
      nameRequired: 'Хуваарийн нэр заавал шаардлагатай',
      nameInUse: '"{{name}}" гэсэн хуваарийн нэрийг ашиглаж байна. Өөр нэр сонгоно уу',
      nameLinked: '"{{name}}" гэсэн хуваарийн нэр өөр хүнтэй холбогдсон байна. Өөр нэр сонгох, эсвэл админаар холбоосыг шилжүүлнэ үү',
      notOnRoster: 'Энэ хүн хуваарьт алга',

      afterLastDay: '{{name}}-ийн сүүлийн ажлын өдөр {{last}}; түүнээс хойшхи {{day}}-нд гүйцэтгэл бүртгэх боломжгүй',
      closedPeriod: 'Энэ өдөр хаагдсан цалингийн үед багтдаг; бүртгэл {{floor}} хүртэл буцна',
      notOnRosterYet: '{{name}} хуваарьт хараахан алга. Эхлээд хуваарьт нэмнэ үү',
      personNotFound: 'Хуваарьт ийм хүн олдсонгүй',
      recordMissing: 'Хүний бүртгэл алга',
      chooseProject: '{{name}}-ийн өдрийг бүртгэх төслийг сонгоно уу',
      chooseProjectOf: '{{name}}-ийн өдрийг бүртгэх төслийг сонгоно уу: {{projects}}-ийн нэг',
      alreadyFiled: '{{name}} {{day}}-нд аль хэдийн бүртгэгдсэн ({{summary}}). Солихын тулд дарж бичих, эсвэл эхлээд өдрийг цуцална уу.',
      noRosterCode: '{{project}} төсөлд энэ ээлжийн код алга тул өдөр бүртгэгдэх ч хуваарьт харагдахгүй. Кодтой төсөл дээр бүртгэнэ үү',
      nothingFiled: '{{day}}-нд бүртгэл алга',
      sharepoint: '{{day}} нь SharePoint импортоос ирсэн тул энд цуцлах боломжгүй: дахин импортлоход буцаад гарч ирнэ. Эх сурвалжийг засна уу.',

      toBeforeFrom: 'to нь from-оос өмнө байна',
      windowMax: 'Хугацаа дээд тал нь {{max}} хоног',

      cellsNonEmpty: 'cells нь хоосон биш жагсаалт байх ёстой',
      cellsMax: 'Нэг хүсэлтэд дээд тал нь {{max}} нүд',
      cellShape: '{{index}}-р нүд {personId, day, was, now} хэлбэртэй биш',
      cellNoId: '{{index}}-р нүдэнд зөв personId, day алга',
      cellStrings: '{{index}}-р нүд: was, now нь тэмдэгт мөр байх ёстой',
      cellRepeats: '{{index}}-р нүд {{person}} {{day}}-г давтаж байна',
      cellProjectString: '{{index}}-р нүд: project нь тэмдэгт мөр байх ёстой',
      outsideHorizon: 'Төлөвлөлтийн хугацаанаас гадуур: {{cells}}',
      cellsNotOnRoster: 'Хуваарьт алга: {{cells}}',
      unknownCodes: 'Хуваарийн кодуудад алга: {{codes}}',
      projectOnlyTransit: 'Төслийг зөвхөн T эсвэл DT нүдэнд тавина: {{cells}}',
      notRosterProject: 'Хуваарийн төсөл биш: {{projects}}',
      cellsChanged: 'Таныг ачаалснаас хойш эдгээр нүд өөрчлөгдсөн. Дахин ачаалаад өөрчлөлтөө дахин хийнэ үү',

      retiredHome: '{{projects}} хаагдсан: үндсэн төсөл идэвхтэй төсөл байх ёстой',
      retiredNamedHome: '{{projects}} хаагдсан: {{name}}-ийн үндсэн төсөл идэвхтэй төсөл байх ёстой',
      retiredPlan: '{{projects}} хаагдсан: нүдийг идэвхтэй төсөлд төлөвлөнө үү',
      retiredFile: '{{projects}} хаагдсан: өдрийг идэвхтэй төсөлд бүртгэнэ үү',
      hiddenPlan: '{{projects}} нуугдсан: нүдийг харагдаж буй төсөлд төлөвлөнө үү',
      hiddenFile: '{{projects}} нуугдсан: өдрийг харагдаж буй төсөлд бүртгэнэ үү',

      shiftNegative: 'Ээлжийн утга сөрөг байх боломжгүй',
      taskNegative: 'Даалгаврын тоо сөрөг байх боломжгүй',
      taskWhole: 'Даалгаврын тоо бүхэл тоо байх ёстой',
      allZero: 'Ээлжийн бүх утга ба даалгаврын тоо тэг байна. Хоосон бүртгэхийн оронд өдрийг цэвэрлэнэ үү',
      shiftOverOne: 'Ээлжийн утга 1-ээс их байх боломжгүй: 1 бол бүтэн ээлж',
      shiftSumOverTwo: 'Нэг өдрийн ээлжийн утгын нийлбэр 2-оос их байх боломжгүй: өдөр ба шөнө, эсвэл ажил ба замын өдөр',
    },
  },
  en: {
    rosterRefusal: {
      blank: '(blank)',
      kind: { day: 'day', night: 'night', transit: 'transit', logging: 'logging', downtime: 'downtime', tasks: 'tasks' },
      noProject: 'no project',
      nothingRecorded: 'nothing recorded',

      layoutShape: 'rowLayout must be an object with order and hidden lists of roster names',
      layoutList: 'rowLayout.{{field}} must be a list of roster names',
      layoutTooMany: 'rowLayout.{{field}} lists {{n}} names; at most {{max}}',
      layoutNameLong: 'rowLayout.{{field}} holds a name longer than {{max}} characters',

      personFieldLong: '{{name}}: {{field}} is longer than {{limit}} characters',
      rolesNotList: '{{name}}: roles must be a list',
      rolesTooMany: '{{name}}: at most {{max}} roles',
      rolesDuplicate: '{{name}}: duplicate roles',
      rolesUnknown: '{{name}}: not in the setup role list: {{roles}}',
      roleFirst: '{{name}}: role must equal the first of roles',

      managerRequired: 'Only a roster manager may do this: full-time staff on the roster who hold roster manager. Ask an administrator.',
      noRole: 'You have no roster role. Ask the roster manager.',
      leaver: 'You have left, so you have no access to the roster',
      noAccessLevel: 'Your account has no access level',
      noProjectPublished: 'You are on no project in the published roster',
      managerNotFullTime: 'You hold roster manager, but only full-time internal staff on the roster can plan it. Ask an administrator.',
      onlyManagerPlans: 'Only a roster manager plans',
      noProjectYet: 'You are on no project yet',

      cellChanged: 'This day was changed elsewhere while this was being saved. Reload and try again',
      noRosterYet: 'This company has no roster yet',

      pastPlan: 'The roster cannot be planned for a day that has already passed: today is {{today}}, refused for {{days}}.',
      pastPlanAdmin: 'The roster cannot be planned for a day that has already passed: today is {{today}}, refused for {{days}}. An administrator can make this change.',
      futureFile: 'A shift cannot be filed for a day that has not happened yet: today is {{today}}, refused for {{days}}.',
      closedMonth: '{{days}} falls in the {{month}} payroll month, which is closed; the roster cannot be planned there. An administrator can make this change.',

      eligibleShape: 'eligible must be a map of project to ids',
      eligibleList: 'eligible[{{project}}] must be a list',
      eligibleNotId: 'eligible[{{project}}]: not an id: {{value}}',

      staffListOf: 'Roster staff of {{project}} must be a list of person ids',
      staffIds: 'Roster staff must be person ids: {{value}}',
      staffMapShape: 'staff must map a project to person ids',
      staffNotPerson: 'Roster staff must be a person on the roster: {{value}}',
      staffNoHome: 'Roster staff need a home project on the roster: {{value}}',
      staffNotProject: '{{who}} cannot be roster staff of {{project}}: it is not a project on the roster',
      staffExternalNamed: '{{who}} cannot be roster staff of {{project}}: only {{staff}} can be roster staff, and they are an external',
      staffExternalOwn: "{{who}} cannot be roster staff of {{project}}: only the company's own staff can be roster staff, and they are an external",
      staffNotPart: '{{who}} cannot be roster staff of {{project}}: they are not part of it (their home project, or a published shift on it)',

      versionStale: 'The roster has changed since you loaded it. Reload the page, then make your change again.',
      cityOnlyWriters: 'Only a roster manager or HR can mark city days.',
      cityNotOnRoster: 'That person is not on the roster.',
      cityEndBeforeStart: 'The end date is before the start date.',
      cityMarkTooLong: 'One mark can cover at most {{max}} days.',
      cityNoMark: 'This mark no longer exists. Reload the page.',
      productNotFound: 'This project was not found. Reload the page.',
      onlyProjectOnRoster: 'Only a project can be on the roster.',
      projectNeedsMongolian: 'A project on the roster needs a Mongolian name.',
      onlyManagerSetsProjects: 'Only a roster manager sets up projects. Ask a roster manager.',
      rosterNameUsed: '{{project}} already uses the roster name {{name}}.',
      rosterNameEnglish: '{{name}} is another product\'s English name. Pick a different roster name.',
      projectInUseRenamed: '{{project}} cannot be renamed while the roster still uses it ({{uses}}). Clear those first.',
      projectInUseOff: '{{project}} cannot be taken off the roster while the roster still uses it ({{uses}}). Clear those first.',
      viewingReadOnly: 'This is read-only while you view as {{who}}. Stop viewing as them and try again.',
      accountInactive: 'This account is inactive. Ask an administrator.',
      leaverPayslips: 'Your employment has ended, so this account can now see only your own payslips.',
      noAccessGranted: 'This account has no access level, so there is nothing here to show. Access has not been granted yet.',
      publicViewOnly: 'This is the public view, which shows only the company dashboard and calendar. It cannot open this page.',
      noEverydayPages: 'This account\'s access level does not include the everyday staff pages. It opens only the pages its level names.',
      missingPermission: 'You do not have permission to do this ({{ability}}).',
      adminRequired: 'Only an administrator can do this.',
      tickAdmin: 'An administrator is always a roster manager, so there is nothing to tick.',
      tickNotStaff: 'Only full-time internal staff on the roster can be a roster manager.',
      tickNoAccount: 'This person has no ordinary account, so the tick would do nothing.',
      tickPasswordHolder: 'This person signs in with a password, and a roster manager signs in with Microsoft only. Remove the password first.',
      tickNeedsEmail: 'A roster manager signs in with a code sent by email, and this person has no email. Add one first.',
      userNotFound: 'This person was not found. Reload the page.',
      stringTooLong: 'This is too long: at most {{max}} characters.',
      stringTooShort: 'This is too short: at least {{min}} characters.',
      publishedView: 'This roster was loaded as the published, filtered view and cannot be saved. Reload the page and reapply your change',
      planReadOnly: 'The Plan changes only by Publish or Clean. Reload the page and save your change to the Draft',
      namesUnresolved: 'These roster names match nobody on record: {{names}}. Add them under an existing person, or have an administrator record the alias first',
      planProjectUnknown: 'planProject: not a roster project: {{projects}}',

      codeExact: 'Code {{code}} has type {{act}}: a T or DT code must be named exactly its type (T is T, DT is DT)',
      codeCategory: 'Code {{code}} already exists, so its category cannot change',
      codeNoProject: 'Code {{code}} has no project: codes not tied to a project cannot be added',
      codeFixedRemoved: 'Code {{code}} is not tied to a project and cannot be removed or renamed',
      codeFixedGivenProject: 'Code {{code}} is not tied to a project and cannot be given one',
      codeFixedType: 'Code {{code}} is not tied to a project, so its type cannot change',

      stackSameType: 'A day cannot hold two shifts of the same type ({{type}}): {{value}}',
      stackTooMany: 'A day cannot hold more than two shifts: {{value}}',
      hoursTransit: 'Transit hours need T in the code, and the code is {{code}}',
      hoursDowntime: 'Downtime hours need DT in the code, and the code is {{code}}',
      hoursTOnly: 'A T day holds transit hours only, and this one also has {{kinds}} hours',

      massClear: '{{n}} planned cells would be cleared. Confirm to clear them',

      publishBeforeToday: 'Publish until ({{day}}) is before today ({{today}}).',
      cleanBeforeToday: 'clean_from: {{day}} is before today ({{today}}); past days stay as they are',
      cleanToBefore: 'clean_to: {{to}} is before {{from}}',
      unknownProject: 'Unknown roster project: {{project}}',
      unknownName: 'Unknown roster name: {{name}}',
      homeNotProject: "{{home}} is not one of the roster's projects",
      noSuchPerson: 'No such person',
      notActiveStaff: '{{name}} is not an active HR staff member and has no last working day left to file. Only they can be added to the roster from here',
      alreadyOnRoster: '{{name}} is already on the roster',
      nameRequired: 'A roster name is required',
      nameInUse: 'The roster name "{{name}}" is already in use. Pick a different one',
      nameLinked: 'The roster name "{{name}}" is already linked to a different person. Pick a different one, or have an administrator move the link first',
      notOnRoster: 'That person is not on the roster',

      afterLastDay: "{{name}}'s last working day is {{last}}; an actual cannot be filed for {{day}}, after it",
      closedPeriod: 'That day is in a closed payroll period; filing reaches back to {{floor}}',
      notOnRosterYet: '{{name}} is not on the roster yet. Add them to the roster first',
      personNotFound: 'Roster person not found',
      recordMissing: 'The person record is missing',
      chooseProject: "Choose the project {{name}}'s day is filed under",
      chooseProjectOf: "Choose the project {{name}}'s day is filed under: one of {{projects}}",
      alreadyFiled: '{{name}} is already filed for {{day}} ({{summary}}). Overwrite it to replace it, or withdraw the day first.',
      noRosterCode: '{{project}} has no roster code for this shift, so the day would be filed but never drawn. File it under a project the roster has codes for',
      nothingFiled: 'Nothing is filed for {{day}}',
      sharepoint: '{{day}} came from the SharePoint import and cannot be withdrawn here: a re-import would bring it straight back. Correct the source.',

      toBeforeFrom: 'to is before from',
      windowMax: 'The window is at most {{max}} days',

      cellsNonEmpty: 'cells must be a non-empty list',
      cellsMax: 'At most {{max}} cells per request',
      cellShape: 'Cell {{index}} is not {personId, day, was, now}',
      cellNoId: 'Cell {{index}} has no valid personId and day',
      cellStrings: 'Cell {{index}}: was and now are strings',
      cellRepeats: 'Cell {{index}} repeats {{person}} {{day}}',
      cellProjectString: 'Cell {{index}}: project is a string',
      outsideHorizon: 'Outside the planning horizon: {{cells}}',
      cellsNotOnRoster: 'Not on the roster: {{cells}}',
      unknownCodes: "Not in the roster's codes: {{codes}}",
      projectOnlyTransit: 'A project is set only on a T or DT cell: {{cells}}',
      notRosterProject: 'Not a roster project: {{projects}}',
      cellsChanged: 'These cells changed since you loaded them. Reload them and reapply',

      retiredHome: '{{projects}} is retired: the home must be an active project',
      retiredNamedHome: "{{projects}} is retired: {{name}}'s home must be an active project",
      retiredPlan: '{{projects}} is retired: plan the cell for an active project',
      retiredFile: '{{projects}} is retired: file the day under an active project',
      hiddenPlan: '{{projects}} is hidden: plan the cell for a shown project',
      hiddenFile: '{{projects}} is hidden: file the day under a shown project',

      shiftNegative: 'A shift value cannot be negative',
      taskNegative: 'A task count cannot be negative',
      taskWhole: 'A task count must be a whole number',
      allZero: 'Every shift value and the task count are zero. Clear the day rather than filing an empty one',
      shiftOverOne: 'A shift value cannot exceed 1: that is a full shift',
      shiftSumOverTwo: "A day's shift values cannot add up to more than 2: a day plus a night, or work plus the transit off site",
    },
  },
  ru: {
    rosterRefusal: {
      blank: '(пусто)',
      kind: { day: 'день', night: 'ночь', transit: 'в пути', logging: 'документация керна', downtime: 'простой', tasks: 'задачи' },
      noProject: 'без проекта',
      nothingRecorded: 'записей нет',

      layoutShape: 'rowLayout должен быть объектом со списками имён графика order и hidden',
      layoutList: 'rowLayout.{{field}} должен быть списком имён графика',
      layoutTooMany: 'В rowLayout.{{field}} имён: {{n}}; максимум: {{max}}',
      layoutNameLong: 'В rowLayout.{{field}} есть имя длиннее допустимого (максимум символов: {{max}})',

      personFieldLong: '{{name}}: поле {{field}} слишком длинное (максимум символов: {{limit}})',
      rolesNotList: '{{name}}: должности должны быть списком',
      rolesTooMany: '{{name}}: максимум должностей: {{max}}',
      rolesDuplicate: '{{name}}: должности повторяются',
      rolesUnknown: '{{name}}: нет в списке должностей настройки: {{roles}}',
      roleFirst: '{{name}}: основная должность должна совпадать с первой в списке',

      managerRequired: 'Это может только менеджер графика: штатный сотрудник полного дня в графике с правом менеджера графика. Обратитесь к администратору.',
      noRole: 'У вас нет роли в графике. Обратитесь к менеджеру графика.',
      leaver: 'Вы уволены, поэтому доступа к графику нет',
      noAccessLevel: 'У вашей учётной записи нет уровня доступа',
      noProjectPublished: 'Вас нет ни в одном проекте опубликованного графика',
      managerNotFullTime: 'У вас есть право менеджера графика, но планировать могут только штатные сотрудники полного дня в графике. Обратитесь к администратору.',
      onlyManagerPlans: 'Планирует только менеджер графика',
      noProjectYet: 'Вы пока не в проекте',

      cellChanged: 'Пока шло сохранение, этот день изменили в другом месте. Перезагрузите и повторите',
      noRosterYet: 'У этой компании пока нет графика',

      pastPlan: 'Нельзя планировать график на прошедший день: сегодня {{today}}, отказано для: {{days}}.',
      pastPlanAdmin: 'Нельзя планировать график на прошедший день: сегодня {{today}}, отказано для: {{days}}. Это может изменить администратор.',
      futureFile: 'Нельзя записать смену на день, который ещё не наступил: сегодня {{today}}, отказано для: {{days}}.',
      closedMonth: '{{days}} относится к закрытому расчётному месяцу {{month}}, планировать там нельзя. Это может изменить администратор.',

      eligibleShape: 'eligible должен сопоставлять проекту список id',
      eligibleList: 'eligible[{{project}}] должен быть списком',
      eligibleNotId: 'eligible[{{project}}]: это не id: {{value}}',

      staffListOf: 'Сотрудники графика проекта {{project}} должны быть списком id людей',
      staffIds: 'Сотрудники графика должны быть id людей: {{value}}',
      staffMapShape: 'staff должен сопоставлять проекту id людей',
      staffNotPerson: 'Сотрудник графика должен быть человеком из графика: {{value}}',
      staffNoHome: 'Сотруднику графика нужен основной проект в графике: {{value}}',
      staffNotProject: '{{who}} не может быть сотрудником графика проекта {{project}}: такого проекта нет в графике',
      staffExternalNamed: '{{who}} не может быть сотрудником графика проекта {{project}}: это могут быть только {{staff}}, а это внешний работник',
      staffExternalOwn: '{{who}} не может быть сотрудником графика проекта {{project}}: это могут быть только собственные сотрудники компании, а это внешний работник',
      staffNotPart: '{{who}} не может быть сотрудником графика проекта {{project}}: этот человек к нему не относится (не основной проект и нет опубликованной смены на нём)',

      versionStale: 'График изменился после загрузки. Обновите страницу и внесите изменение снова.',
      cityOnlyWriters: 'Отмечать дни в городе может только менеджер графика или отдел кадров.',
      cityNotOnRoster: 'Этого человека нет в графике.',
      cityEndBeforeStart: 'Дата окончания раньше даты начала.',
      cityMarkTooLong: 'Одна отметка охватывает не более {{max}} дн.',
      cityNoMark: 'Этой отметки больше нет. Обновите страницу.',
      productNotFound: 'Этот проект не найден. Обновите страницу.',
      onlyProjectOnRoster: 'В графике может быть только проект.',
      projectNeedsMongolian: 'Проекту в графике нужно монгольское название.',
      onlyManagerSetsProjects: 'Проекты настраивает только менеджер графика. Обратитесь к менеджеру графика.',
      rosterNameUsed: '{{project}} уже использует в графике название {{name}}.',
      rosterNameEnglish: '{{name}}: это английское название другого продукта. Выберите другое название для графика.',
      projectInUseRenamed: '{{project}} нельзя переименовать, пока он используется в графике ({{uses}}). Сначала очистите это.',
      projectInUseOff: '{{project}} нельзя убрать из графика, пока он там используется ({{uses}}). Сначала очистите это.',
      viewingReadOnly: 'В режиме просмотра от имени {{who}} можно только читать. Выйдите из просмотра и повторите.',
      accountInactive: 'Эта учётная запись неактивна. Обратитесь к администратору.',
      leaverPayslips: 'Ваша работа завершена, поэтому в этой учётной записи видны только ваши расчётные листки.',
      noAccessGranted: 'У этой учётной записи нет уровня доступа, поэтому здесь нечего показать. Доступ ещё не предоставлен.',
      publicViewOnly: 'Это публичный режим: только панель и календарь компании. Эту страницу в нём открыть нельзя.',
      noEverydayPages: 'Уровень доступа этой учётной записи не включает повседневные страницы сотрудников. Открываются только страницы, указанные в уровне.',
      missingPermission: 'У вас нет права на это действие ({{ability}}).',
      adminRequired: 'Это может только администратор.',
      tickAdmin: 'Администратор всегда менеджер графика, отмечать не нужно.',
      tickNotStaff: 'Менеджером графика может быть только штатный сотрудник на полную ставку из графика.',
      tickNoAccount: 'У этого человека нет обычной учётной записи, поэтому отметка ничего не даст.',
      tickPasswordHolder: 'Этот человек входит по паролю, а менеджер графика входит только через Microsoft. Сначала удалите пароль.',
      tickNeedsEmail: 'Менеджер графика входит по коду из письма, а у этого человека нет почты. Сначала укажите её.',
      userNotFound: 'Этот человек не найден. Обновите страницу.',
      stringTooLong: 'Слишком длинно: не более {{max}} симв.',
      stringTooShort: 'Слишком коротко: не менее {{min}} симв.',
      publishedView: 'График загружен как опубликованный отфильтрованный вид, его нельзя сохранить. Перезагрузите страницу и повторите изменение',
      planReadOnly: 'План меняется только через «Опубликовать» или «Очистить». Перезагрузите страницу и сохраните изменение в черновик',
      namesUnresolved: 'Эти имена в графике ни с кем не совпадают: {{names}}. Добавьте их к существующему человеку или попросите администратора сначала записать псевдоним',
      planProjectUnknown: 'planProject: не проект графика: {{projects}}',

      codeExact: 'У кода {{code}} тип {{act}}: код T или DT должен называться точно как его тип (T это T, DT это DT)',
      codeCategory: 'Код {{code}} уже существует, поэтому его категорию менять нельзя',
      codeNoProject: 'У кода {{code}} нет проекта: коды без проекта добавлять нельзя',
      codeFixedRemoved: 'Код {{code}} не привязан к проекту, его нельзя удалить или переименовать',
      codeFixedGivenProject: 'Код {{code}} не привязан к проекту, и назначить ему проект нельзя',
      codeFixedType: 'Код {{code}} не привязан к проекту, поэтому его тип менять нельзя',

      stackSameType: 'В одном дне не может быть двух смен одного типа ({{type}}): {{value}}',
      stackTooMany: 'В одном дне не может быть больше двух смен: {{value}}',
      hoursTransit: 'Для часов в пути в коде нужен T, а код: {{code}}',
      hoursDowntime: 'Для часов простоя в коде нужен DT, а код: {{code}}',
      hoursTOnly: 'День T содержит только часы в пути, а в этом есть ещё часы: {{kinds}}',

      massClear: 'Запланированных ячеек будет очищено: {{n}}. Подтвердите очистку',

      publishBeforeToday: '«Опубликовать до» ({{day}}) раньше сегодняшнего дня ({{today}}).',
      cleanBeforeToday: 'clean_from: {{day}} раньше сегодняшнего дня ({{today}}); прошедшие дни остаются как есть',
      cleanToBefore: 'clean_to: {{to}} раньше {{from}}',
      unknownProject: 'Неизвестный проект графика: {{project}}',
      unknownName: 'Неизвестное имя в графике: {{name}}',
      homeNotProject: '{{home}} не входит в проекты графика',
      noSuchPerson: 'Такого человека нет',
      notActiveStaff: '{{name}} не является активным сотрудником HR, и у этого человека не осталось последнего рабочего дня для записи. Отсюда в график добавляются только такие сотрудники',
      alreadyOnRoster: '{{name}} уже в графике',
      nameRequired: 'Нужно имя в графике',
      nameInUse: 'Имя в графике «{{name}}» уже занято. Выберите другое',
      nameLinked: 'Имя в графике «{{name}}» уже связано с другим человеком. Выберите другое или попросите администратора сначала перенести связь',
      notOnRoster: 'Этого человека нет в графике',

      afterLastDay: 'Последний рабочий день: {{name}}, {{last}}; факт за {{day}}, после него, записать нельзя',
      closedPeriod: 'Этот день в закрытом расчётном периоде; запись возможна только начиная с {{floor}}',
      notOnRosterYet: '{{name}} пока нет в графике. Сначала добавьте в график',
      personNotFound: 'Человек в графике не найден',
      recordMissing: 'Запись о человеке отсутствует',
      chooseProject: 'Выберите проект для дня: {{name}}',
      chooseProjectOf: 'Выберите проект для дня: {{name}}. Один из: {{projects}}',
      alreadyFiled: '{{name}}: день {{day}} уже записан ({{summary}}). Перезапишите его или сначала отмените день.',
      noRosterCode: 'У проекта {{project}} нет кода графика для этой смены: день запишется, но не отобразится. Запишите его на проект, у которого есть коды',
      nothingFiled: 'За {{day}} ничего не записано',
      sharepoint: '{{day}} пришёл из импорта SharePoint, отменить его здесь нельзя: повторный импорт сразу вернёт его. Исправьте источник.',

      toBeforeFrom: 'to раньше from',
      windowMax: 'Период не больше {{max}} дн.',

      cellsNonEmpty: 'cells должен быть непустым списком',
      cellsMax: 'Максимум ячеек в запросе: {{max}}',
      cellShape: 'Ячейка {{index}} не вида {personId, day, was, now}',
      cellNoId: 'У ячейки {{index}} нет правильных personId и day',
      cellStrings: 'Ячейка {{index}}: was и now должны быть строками',
      cellRepeats: 'Ячейка {{index}} повторяет {{person}} {{day}}',
      cellProjectString: 'Ячейка {{index}}: project должен быть строкой',
      outsideHorizon: 'За пределами горизонта планирования: {{cells}}',
      cellsNotOnRoster: 'Нет в графике: {{cells}}',
      unknownCodes: 'Нет среди кодов графика: {{codes}}',
      projectOnlyTransit: 'Проект задаётся только в ячейке T или DT: {{cells}}',
      notRosterProject: 'Не проект графика: {{projects}}',
      cellsChanged: 'Эти ячейки изменились после загрузки. Перезагрузите их и повторите изменения',

      retiredHome: '{{projects}}: проект закрыт, основным должен быть активный проект',
      retiredNamedHome: '{{projects}}: проект закрыт, основным проектом ({{name}}) должен быть активный проект',
      retiredPlan: '{{projects}}: проект закрыт, планируйте ячейку на активный проект',
      retiredFile: '{{projects}}: проект закрыт, запишите день на активный проект',
      hiddenPlan: '{{projects}}: проект скрыт, планируйте ячейку на показанный проект',
      hiddenFile: '{{projects}}: проект скрыт, запишите день на показанный проект',

      shiftNegative: 'Значение смены не может быть отрицательным',
      taskNegative: 'Число задач не может быть отрицательным',
      taskWhole: 'Число задач должно быть целым',
      allZero: 'Все значения смены и число задач равны нулю. Очистите день вместо записи пустого',
      shiftOverOne: 'Значение смены не может быть больше 1: это полная смена',
      shiftSumOverTwo: 'Сумма значений смен за день не может быть больше 2: день плюс ночь или работа плюс дорога',
    },
  },
}
